import { ROLE_LABELS } from "../../data/seedData";

const ROLE_STYLES = {
  ADMIN: "bg-amber-500 text-white border-amber-500",
  IRBAN: "bg-slate-800 text-white border-slate-800",
  DALNIS: "bg-blue-100 text-blue-800 border-blue-200",
  KETUA_TIM: "bg-emerald-100 text-emerald-800 border-emerald-200",
  ANGGOTA_TIM: "bg-gray-100 text-gray-800 border-gray-200",
};

export default function RoleBadge({ role, className = "" }) {
  const style = ROLE_STYLES[role] || "bg-gray-100 text-gray-800 border-gray-200";
  const label = ROLE_LABELS[role] || role;
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold border ${style} ${className}`}
    >
      {label}
    </span>
  );
}
